import React from "react";
import Chips from "./Chips/Chips";
import TopBarButton from "./TopBarButton/TopBarButton";
import InfoSection from "./InfoSection/InfoSection";
import BettingCon from "./BettingCon/BettinCon";
import VolumeButton from "./VolumeButton/VolumeButton";
import Countdown from "./Countdown/Countdown";
import { useGameStateStore } from "../../stores/gameStateStore";
import { handleSignOut, handlExpand, handleHistory } from "./Functions";

import "./Topbar.css";


export default function Topbar() {
  const roundStatus = useGameStateStore(s => s.roundStatus);
  const isDisabled = roundStatus !== "waiting";

  return (
    <div id="top-bar">
      <LeftSideInfo isDisabled={isDisabled} />
      <Chips className="chips" isDisabled={isDisabled} />
      < RightSideInfo />
    </div>
  )
}


function LeftSideInfo({ isDisabled }: { isDisabled: boolean }) {

  return (
    <div className="top-bar-left">
      <TopBarButton className="fa fa-sign-out" onClick={() => handleSignOut()} />
      <TopBarButton className="fa fa-history" onClick={() => handleHistory()} />
      <VolumeButton />
      <InfoSection text="100K" textClassName="yellow-text" className="fa fa-trophy" />
      <BettingCon isClosed={isDisabled} />
      <Countdown />
    </div>
  )
}


function RightSideInfo() {
  return (
    <div className="top-bar-right">
      <InfoSection text="testuser" className="fa fa-user" />
      <InfoSection text="10K" className="fa fa-coins" />
      <TopBarButton className="fa fa-expand" onClick={() => handlExpand()} />
    </div>
  )
}